export const typeMetadata = {
  // Infrastructure
  Hovedmåler: { color: '#A6AEBF', icon: 'fa-gauge', group: 'Hovedmåler' },
  Tavle: { color: '#A888B5', icon: 'fa-chart-diagram', group: 'Tavle' },
  Undertavle: {
    color: '#8174A0',
    icon: 'fa-diagram-project',
    group: 'Undertavle',
  },
  Bygning: { color: '#006A67', icon: 'fa-building', group: 'Diverse' },
  Etage: { color: '#740938', icon: 'fa-layer-group', group: 'Diverse' },
  'P-kælder': { color: '#5D4037', icon: 'fa-warehouse', group: 'Diverse' },
  Skurby: { color: '#8D6E63', icon: 'fa-home', group: 'Byggeplads' },
  'Materiale Container': {
    color: '#4E342E',
    icon: 'fa-box-open',
    group: 'Byggeplads',
  },
  Gruppe: { color: '#CDC1FF', icon: 'fa-cubes-stacked', group: 'Diverse' },

  // Kontor
  Lys: { color: '#FFC107', icon: 'fa-lightbulb', group: 'Kontor' },
  Køling: { color: '#78B3CE', icon: 'fa-snowflake', group: 'Kontor' },
  Ventilation: { color: '#C9E6F0', icon: 'fa-fan', group: 'Kontor' },
  Elevator: {
    color: '#9E9E9E',
    icon: 'fa-arrow-up-right-dots',
    group: 'Kontor',
  },
  Serverrum: { color: '#3E7CB1', icon: 'fa-server', group: 'Kontor' },
  Pumper: { color: '#1E88E5', icon: 'fa-water', group: 'Kontor' },
  Ladestander: {
    color: '#4CAF50',
    icon: 'fa-charging-station',
    group: 'Kontor',
  },
  Køkken: { color: '#FF7043', icon: 'fa-utensils', group: 'Kontor' },
  Udendørsbelysning: {
    color: '#FFD600',
    icon: 'fa-lightbulb',
    group: 'Kontor',
  },

  // Byggeplads
  Kran: { color: '#B71C1C', icon: 'fa-industry', group: 'Byggeplads' },
  Varmepumpe: { color: '#FFA726', icon: 'fa-fire', group: 'Byggeplads' },
  Trykluft: { color: '#009688', icon: 'fa-wind', group: 'Byggeplads' },
  Batteri: { color: '#673AB7', icon: 'fa-battery-full', group: 'Byggeplads' },

  // Skole
  Ventilationsanlæg: { color: '#80CBC4', icon: 'fa-fan', group: 'Skole' },
  SFO: { color: '#FF80AB', icon: 'fa-child', group: 'Skole' },
  Idrætshal: { color: '#1976D2', icon: 'fa-dumbbell', group: 'Skole' },

  // Industri
  Processudstyr: { color: '#8E24AA', icon: 'fa-microchip', group: 'Industri' },
  Udsugning: { color: '#3D5AFE', icon: 'fa-smog', group: 'Industri' },
  Motor: { color: '#689F38', icon: 'fa-cogs', group: 'Industri' },
  Svejser: { color: '#D84315', icon: 'fa-wrench', group: 'Industri' },
  'Elektriske apparater': {
    color: '#FFB74D',
    icon: 'fa-plug',
    group: 'Industri',
  },
  Ovne: { color: '#F44336', icon: 'fa-fire-burner', group: 'Industri' },

  // Portefølje
  Administration: {
    color: '#607D8B',
    icon: 'fa-briefcase',
    group: 'Portefølje',
  },
  Ældrepleje: {
    color: '#B39DDB',
    icon: 'fa-hands-holding',
    group: 'Portefølje',
  },
  Beredskab: {
    color: '#E53935',
    icon: 'fa-shield-halved',
    group: 'Portefølje',
  },
  Daginstitution: { color: '#FDD835', icon: 'fa-baby', group: 'Portefølje' },
  Uddanelsesinstitutioner: {
    color: '#5E35B1',
    icon: 'fa-graduation-cap',
    group: 'Portefølje',
  },
  Infrastruktur: { color: '#546E7A', icon: 'fa-road', group: 'Portefølje' },
  Kultur: { color: '#F06292', icon: 'fa-theater-masks', group: 'Portefølje' },
  'Offentlige institutioner': {
    color: '#0097A7',
    icon: 'fa-landmark',
    group: 'Portefølje',
  },
  Socialpleje: {
    color: '#EF9A9A',
    icon: 'fa-hand-holding-heart',
    group: 'Portefølje',
  },
  Ungdomstilbud: { color: '#81C784', icon: 'fa-users', group: 'Portefølje' },

  // Misc
  Forbruger: { color: '#9ABF80', icon: 'fa-bolt', group: 'Diverse' },
  Område: { color: '#EB5B00', icon: 'fa-compass', group: 'Diverse' },
  Andet: { color: '#9E9E9E', icon: 'fa-question-circle', group: 'Diverse' },
  IkkeAnalyseret: { color: '#434343', icon: 'fa-ban', group: 'Diverse' },
  Analyseret: {
    color: '#434343',
    icon: 'fa-magnifying-glass-chart',
    group: 'Diverse',
  },
};

export function getTypeColor(type) {
  return typeMetadata[type]?.color ?? '#555';
}

export function getTypeIcon(type) {
  return typeMetadata[type]?.icon ?? 'fa-question-circle';
}

export function getTypeGroup(type) {
  return typeMetadata[type]?.group ?? 'Diverse';
}

// Grouped for rendering <optgroup>
export function getGroupedOptions() {
  const grouped = {};

  Object.entries(typeMetadata).forEach(([type, meta]) => {
    const group = meta.group;
    if (!grouped[group]) grouped[group] = [];
    grouped[group].push({ value: type, label: type, icon: meta.icon });
  });

  return grouped;
}
